<template>
  <div>
    <div class="product-window" :class="attr.cartAttr === true ? 'on' : ''">
      <div class="textpic acea-row row-between-wrapper">
        <div class="pictrue">
          <img :src="attr.productSelect.image" class="image" />
        </div>
        <div class="text">
          <div class="line1">{{ attr.productSelect.title }}</div>
          <div class="money font-color-red">
            ￥<span class="num">{{ attr.productSelect.price }}</span>
            <span class="stock">库存: {{ attr.productSelect.stock }}</span>
          </div>
        </div>
        <div class="iconfont icon-guanbi" @click="closeAttr"></div>
      </div>
      <div class="productWinList">
        <div class="item" v-for="(opitons, key) in attr.productAttr" :key="key">
          <div class="title">{{ key }}</div>
          <div class="listn acea-row row-middle">
            <div
              class="itemn"
              :class="attr.selectOpts[key] === idx ? 'on' : ''"
              v-for="(option, idx) in opitons"
              @click="tapAttr(key, idx)"
              :key="idx"
            >
              {{ option }}
            </div>
          </div>
        </div>
      </div>
      <div class="cart">
        <div class="title">数量</div>
        <div class="carnum acea-row row-left">
          <div
            class="item reduce"
            :class="attr.productSelect.num <= 1 ? 'on' : ''"
            @click="CartNumDes"
          >
            -
          </div>
          <div class="item num">{{ attr.productSelect.num }}</div>
          <div
            class="item plus"
            :class="
              attr.productSelect.num >= attr.productSelect.stock ? 'on' : ''
            "
            @click="CartNumAdd"
          >
            +
          </div>
        </div>
      </div>
    </div>
    <div
      class="mask"
      @touchmove.prevent
      :hidden="attr.cartAttr === false"
      @click="closeAttr"
    ></div>
  </div>
</template>
<script>
export default {
  name: "ProductWindow",
  props: {
    attr: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {};
  },
  mounted: function () {},
  methods: {
    closeAttr: function () {
      this.$emit("changeFun", { action: "changeattr", value: false });
    },
    CartNumDes: function () {
      this.$emit("changeFun", { action: "ChangeCartNum", value: false });
    },
    CartNumAdd: function () {
      this.$emit("changeFun", { action: "ChangeCartNum", value: 1 });
    },
    tapAttr: function (key, indexn) {
      this.attr.selectOpts[key] = indexn;
      let opts = Object.values(this.attr.selectOpts);
      console.info(this.attr, this.attr.selectOpts, opts);
      this.$emit("changeFun", { action: "ChangeAttr", value: opts.join("_") });
    },
  },
};
</script>
